import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export const chartColors = {
  emerald: "#34d399",
  rose: "#fb7185",
  sky: "#38bdf8",
  amber: "#fbbf24",
  grid: "rgba(148, 163, 184, 0.1)",
  tick: "#94a3b8",
};

export function baseLineOptions(yLabel?: string) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index" as const, intersect: false },
    plugins: {
      legend: {
        labels: { color: chartColors.tick, usePointStyle: true, boxHeight: 6 },
      },
      tooltip: {
        backgroundColor: "#0f172a",
        borderColor: "#1e293b",
        borderWidth: 1,
        titleColor: "#e2e8f0",
        bodyColor: "#cbd5e1",
      },
    },
    scales: {
      x: {
        grid: { color: chartColors.grid },
        ticks: { color: chartColors.tick, maxRotation: 0, autoSkipPadding: 16 },
      },
      y: {
        title: yLabel ? { display: true, text: yLabel, color: chartColors.tick } : undefined,
        grid: { color: chartColors.grid },
        ticks: { color: chartColors.tick },
      },
    },
  };
}
